import Processo from "@pages/Processo/Processo";

export default Processo;
